import ApiService from "../apiService";
import { ApiEndpoints } from "../../api/endpoints";
import store from "../../store";
import { setAuthentication } from "./authenticationHelpers";
class AuthenticationService {
    constructor() {
        this.requestLogOut = async () => {
            store.auth.setIsAppLoading(true);
            await this.logOut();
            setAuthentication(null);
            store.auth.logout();
            store.auth.setIsAppLoading(false);
        };
        this.loginUserAndFetchAccessDetails = async (account) => {
            store.auth.login(account);
            const { data } = await ApiService.get(ApiEndpoints.account.getUserAccessDetails);
            store.auth.updateUserAccessDetails(data);
        };
    }
}
export default AuthenticationService;
